<script setup lang="ts">
import FormBlock from '@/components/Overview/FormBlock.vue'
import CushionForm from '@/components/CanvasCushion/CushionForm.vue'
import { useStore } from '@/stores/store'
import { storeToRefs } from 'pinia'
import { computed, nextTick, onMounted, onUpdated, ref, useTemplateRef } from 'vue'

const store = useStore()
const { currentStep, diameter_a_circle, width_a_rectangle, length_b_rectangle, fabrics } =
  storeToRefs(store)
const showCanvas = computed(() =>
  store.isCircle
    ? Number(diameter_a_circle.value) >= 30
    : Number(width_a_rectangle.value) >= 30 && Number(length_b_rectangle.value) >= 30,
)
const rightFormWrapperWidth = ref(0)
const rightFormWrapperHeight = ref(0)
const rightFormWrapper = useTemplateRef('rightFormWrapper')
function saveCushionImage() {
  const canvasHolderElement = document.getElementsByClassName('konvajs-content')[0]
  const firstCanvasLayer = canvasHolderElement.children[0] as HTMLCanvasElement
  const secondCanvasLayer = canvasHolderElement.children[1] as HTMLCanvasElement
  const thirdCanvasLayer = canvasHolderElement.children[2] as HTMLCanvasElement

  const cushionRender = document.getElementById('2d-cushion-render') as HTMLCanvasElement

  cushionRender.width = firstCanvasLayer.width
  cushionRender.height = firstCanvasLayer.height

  // let firstCanvasLayerContext = firstCanvasLayer.getContext('2d');
  // let secondCanvasLayerContext = secondCanvasLayer.getContext('2d');
  // let thirdCanvasLayerContext = thirdCanvasLayer.getContext('2d');
  const cushionRenderContext = cushionRender.getContext('2d')
  if (cushionRenderContext) {
    cushionRenderContext.drawImage(firstCanvasLayer, 0, 0)
    cushionRenderContext.drawImage(secondCanvasLayer, 0, 0)
    cushionRenderContext.drawImage(thirdCanvasLayer, 0, 0)
  }
}
onUpdated(() => {
  nextTick(() => {
    if (rightFormWrapper.value) {
      rightFormWrapperWidth.value = rightFormWrapper.value?.offsetWidth || 0
      rightFormWrapperHeight.value = rightFormWrapper.value?.offsetHeight || 0
    }
  })
})
onMounted(() => {
  rightFormWrapperWidth.value = rightFormWrapper.value?.offsetWidth || 0
  rightFormWrapperHeight.value = rightFormWrapper.value?.offsetHeight || 0
})
</script>

<template>
  <div v-if="currentStep === 4">
    <div class="constructor flex">
      <div class="left-form-wrapper">
        <FormBlock />
      </div>
      <div class="rightFormWrapper" style="height: auto; min-width: 200px; z-index: -1">
        <div class="flex justify-center items-center mb-4" v-if="fabrics.data.image">
          <img
            class="object-cover w-full max-w-[106px]"
            :src="fabrics.data.image"
            :alt="fabrics.data.name"
          />
        </div>
        <div ref="rightFormWrapper" style="height: 200px; width: 200px">
          <CushionForm
            v-if="showCanvas"
            @onformdraw="saveCushionImage"
            :parent-width="rightFormWrapperWidth"
            :parent-height="rightFormWrapperHeight"
          />
        </div>

        <span class="text-black/60">{{ $t('*The images are indicative') }}</span>
      </div>
    </div>
  </div>
</template>
